import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/fermentations/$group_id/aftercare")({
  component: AftercareLayout,
});

function AftercareLayout() {
  return (
    <div className="flex h-full">
      {/* Main content area */}
      <div className="flex-1 overflow-y-auto max-w-4xl">
        <Outlet />
      </div>
    </div>
  );
}

